import React from "react";
import MatchWithWordsGame from "./components/MatchWithWordsGame";
import "./index.css";

function App() {
  return (
    <div className="App">
      <MatchWithWordsGame />
    </div>
  );
}

export default App;
